export enum MileageUnits {
  Kilometres = 'Kilometres',
  Miles = 'Miles',
}

export enum CurrencyUnits {
  Euros = 'EUR',
  GreatBritishPounds = 'GBP',
}
